import SwitchableTextareaSystem from './SwitchableTextareaSystem';
import './SwitchableTextareaSystem.scss';

export default SwitchableTextareaSystem;
